import { Icon16DownloadOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { useEffect } from 'react';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './DownloadCounter.css';

export type DownloadCounterProps = {
    downloads: number;
    downloadLimit: number;
    isMobile?: boolean;
    onClick: (e) => void;
    isListViewMobile?: boolean;
    isGalleryView?: boolean;
    isNewDataList?: boolean;
    className?: string;
    animate?: boolean;
};

const DownloadCounter = ({
    downloads,
    downloadLimit,
    isMobile,
    onClick,
    isListViewMobile,
    isGalleryView,
    isNewDataList,
    className,
    animate,
}: DownloadCounterProps) => {
    const isAchievedLimit = downloads >= downloadLimit;

    const sendAnalytics = (action) => {
        sendDwh({ eventCategory: 'count_limit_sharing', action, dwhData: { count: downloads } });
    };

    useEffect(() => {
        sendAnalytics('view');
    }, []);

    const handleClick = (e) => {
        sendAnalytics('click');
        onClick(e);
    };

    return (
        <div
            className={classNames(styles.borderCounter, className, {
                [styles.borderCounterAchived]: isAchievedLimit && !isMobile && !isListViewMobile && !isGalleryView,
                [styles.borderCounterMobile]: isMobile,
                [styles.borderCounterTableViewMobileAchived]: isMobile && isAchievedLimit && !isListViewMobile && !isGalleryView,
                [styles.achievedLimitMobile]: isListViewMobile && isAchievedLimit,
                [styles.borderCounterListViewMobile]: isListViewMobile,
                [styles.borderCounterListViewMobileAchived]: isListViewMobile && isAchievedLimit,
                [styles.borderCounterGalleryView]: isGalleryView,
                [styles.borderCounterGalleryViewAchived]: isGalleryView && isAchievedLimit,
                [styles.borderCounterNewDataList]: isNewDataList,
            })}
            onClick={handleClick}
        >
            <Icon16DownloadOutline
                className={classNames(styles.counter, {
                    [styles.achievedLimit]: isAchievedLimit,
                    [styles.textGalleryViewMobile]: isGalleryView,
                    [styles.counter_newlist]: isNewDataList && !isAchievedLimit,
                    [styles.hovered]: isNewDataList && animate,
                })}
            />
            <div
                className={classNames(styles.counter, {
                    [styles.achievedLimit]: isAchievedLimit,
                    [styles.textGalleryViewMobile]: isGalleryView,
                    [styles.counter_newlist]: isNewDataList && !isAchievedLimit,
                    [styles.hovered]: isNewDataList && animate,
                })}
            >
                {downloads}
            </div>
        </div>
    );
};

export default DownloadCounter;
